var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiugaiyanse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.03125L0.84375 8.6875L6.5625 15.25L14.25 9.03125Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.58058,
    y: 2.41949,
    width: 8.59725,
    height: 9.82043,
    transform: "rotate(50.5985 8.58058 2.41949)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77432 0.650269L3.76425 3.94435",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.9692C16 12.5537 15.5262 13.0274 14.9418 13.0274C14.3574 13.0274 13.8836 12.5537 13.8836 11.9692C13.8836 11.3848 14.9418 10.1614 14.9418 10.1614C14.9418 10.1614 16 11.3848 16 11.9692Z",
    fill: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiugaiyanse);
export default __webpack_public_path__ + "static/media/xiugaiyanse.3dad64288d5179df26186b798dd45cb5.svg";
export { ForwardRef as ReactComponent };